<div class="chart">
  <div class="select-field">
    <mat-label>{{ 'graph_select_indicator' | translate }}</mat-label>
    <div class="mt-4">
      <span *ngFor="let indicator of indicators" class="ms-2 me-2 align-checkbox-text">
        <mat-checkbox [checked]="indicator.isChecked" (change)="onChangeIndicatorSelect($event, indicator)"> {{ indicator.displayName | localizedLabel: 'indicator' : indicator.code }} ({{ indicator.workUnityDisplayShortName }}) </mat-checkbox>
      </span>
    </div>
  </div>

  <highcharts-chart appAutoReflow class="chart-graph" *ngIf="indicatorComparatif.indicatorId" [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag" [oneToOne]="true"> </highcharts-chart>
</div>
